import { generatePath, useLocation, useNavigate } from 'react-router-dom';

import { Notification, NpsPromptService } from 'us-web-services';
import { Storage } from '../../../constants';
import { useDependencies } from '../../../dependencies';
import { Routes } from '../../../Routes';
import { Button } from '../../Button/Button';

interface Props {
  data: Notification;
}

const NotificationItem = ({ data }: Props): JSX.Element => {
  const {
    stores: {
      user: { user },
    },
  } = useDependencies();
  const location = useLocation();
  const navigate = useNavigate();

  const updateNpsPrompt = async (id: number): Promise<void> => {
    const params = {
      id,
      userId: user.id,
    };
    await NpsPromptService.update(id, params);
    localStorage.removeItem(Storage.NPS_PROMPT_ID);
  };

  const navigateToFeedback = (): void => {
    localStorage.setItem(Storage.NPS_FEEDBACK_SOURCE, location.pathname);
    navigate(Routes.feedback);
  };

  const handleClick = (): void => {
    if (data.bookingId) {
      navigate(generatePath(Routes.bookings.id, { id: data.bookingId.toString() }));
    } else if (data.referredSitterId) {
      navigate(generatePath(Routes.sitter.profile, { id: data.referredSitterId.toString() }));
    } else if (data.jobId && user?.parent) {
      navigate(generatePath(Routes.job.applicant, { id: data.jobId.toString(), userId: data.sender?.id?.toString() }));
    } else if (data.jobId && user?.sitter) {
      navigate(generatePath(Routes.job.id, { id: data.jobId.toString() }));
    } else if (data.promptId) {
      updateNpsPrompt(data.promptId);
      navigateToFeedback();
    } else if (data.backgroundCheckId) {
      navigate(Routes.backgroundCheck);
    } else if (data.parentIdToReview) {
      navigate(generatePath(Routes.parent.feedback, { id: data.parentIdToReview.toString() }));
    } else if (data.target === 'payout-methods') {
      navigate(Routes.sitter.payout);
    } else {
      navigate(Routes.parent.sitters);
    }
  };

  return (
    <Button onClick={handleClick} className='text-left w-full border-b p-4 hover:bg-gray-100 active:bg-gray-200'>
      <span className='font-bold'>{data.label}</span>
      <p>{data.message}</p>
    </Button>
  );
};

export default NotificationItem;
